module.exports = __webpack_public_path__ + "media/img/vca/nomf2-25f42f42f61eaab4b7baf9395d52b5aa.png";